import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import { url } from "../Constent/Constant";

const ServiceInclude = ({ Data, UpdateImage, UpdateText }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [UpdateId, setUpdateId] = useState('')
    const history = useHistory()

    
    const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setUpdateId(id)
    };

    const showImageModal = (id) => {
        setImageModal(true);
        setUpdateId(id)
    };


    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: UpdateId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: UpdateId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if (event.key === 'Enter') {
            console.log('Enter Clicked')
            a.concat('\n')
            setHeadingUpdate(a)
        } else {
            console.log(event.key)
        }
    }

    return (
        <div className='ServiceInclude-container'>
            <div className='Left-section'>
                <h2 className='Heading'> {Data ? Data.section4heading1.content : 'No Text'}
                    <i onClick={() => ShowTextModal(Data.section4heading1._id)} className="far fa-edit Edit-btn"></i>
                </h2>
                <div className='Para-div'>
                    <i onClick={() => ShowTextModal(Data.section4paragraph1._id)} className="far fa-edit Edit-btn"></i>
                    <p> {Data ? Data.section4paragraph1.content : 'No Text'} </p>
                </div>
                <button onClick={() => history.push('/Storage')} className='Primary-btn Button'>Learn More</button>
                {/* <div className='Image-div'>
                <i onClick={() => showImageModal(Data.section4image1._id)} className="far fa-edit Edit-btn"></i>
                <img src={`${url}/api/getFile${Data.section4image1.image}`} alt='Img' draggable={false} />
                </div> */}
            </div>
            <div className='Right-section'>
                <div className='Container'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(Data.section4image2._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${Data.section4image2.image}`} alt='icon' draggable={false} />
                    </div>
                    <h3>{Data ? Data.section4heading2.content : 'No Text'}
                        <i onClick={() => ShowTextModal(Data.section4heading2._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(Data.section4paragraph2._id)} className="far fa-edit Edit-btn"></i>
                        <p> {Data ? Data.section4paragraph2.content : 'No Text'}<span onClick={() => history.push('/PackingAndUnpacking')} className='LearnMore'>Learn more</span> </p>
                    </div>
                </div>
                <div className='Container'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(Data.section4image3._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${Data.section4image3.image}`} alt='icon' draggable={false} />
                    </div>
                    <h3>{Data ? Data.section4heading3.content : 'No Text'}
                        <i onClick={() => ShowTextModal(Data.section4heading3._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(Data.section4paragraph3._id)} className="far fa-edit Edit-btn"></i>
                        <p> {Data ? Data.section4paragraph3.content : 'No Text'}  </p>
                    </div>
                </div>
                <div className='Container'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(Data.section4image4._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${Data.section4image4.image}`} alt='icon' draggable={false} />
                    </div>
                    <h3>{Data ? Data.section4heading4.content : 'No Text'}
                        <i onClick={() => ShowTextModal(Data.section4heading4._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(Data.section4paragraph4._id)} className="far fa-edit Edit-btn"></i>
                        <p> {Data ? Data.section4paragraph4.content : 'No Text'} <span onClick={() => history.push('/Storage')} className='LearnMore'>Learn more</span> </p>
                    </div>
                </div>
                <div className='Container'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(Data.section4image5._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${Data.section4image5.image}`} alt='icon' draggable={false} />
                    </div>
                    <h3>{Data ? Data.section4heading5.content : 'No Text'}
                        <i onClick={() => ShowTextModal(Data.section4heading5._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(Data.section4paragraph5._id)} className="far fa-edit Edit-btn"></i>
                        <p> {Data ? Data.section4paragraph5.content : 'No Text'} <span onClick={() => history.push('/MilitaryMoving')} className='LearnMore'>Learn more</span> </p>
                    </div>
                </div>
            </div>


            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>

        </div>
    )
}

export default ServiceInclude
